import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { apiService } from './components/Config/api.service';

import CreateUserCompany from './pages/Connexion/Inscription';
import Login from './pages/Connexion/Login';
import Deconnexion from './pages/Connexion/Deconnexion';

// import Header from './components/Header/Header';
import SidebarNav from './components/SideBar/SidebarNav';
// import Footer from './components/Footer/Foot';

// Importez le nouveau composant LogoutModal
import LogoutModal from './pages/Connexion/LogoutModal';

import Home from './pages/Home/Home';
import About from './pages/About/About';
import Contact from './pages/Contact/Contact';
// import Calendar from './pages/Calendar/Calendar';

import Employees from './pages/Employee/Employees';
import EmployeeNew from './pages/Employee/EmployeeNew';
import Employee from './pages/Employee/EmployeeDetails';
import Contracts from './pages/Employee/Contract/Contracts';


import Primes from './pages/Primes/Primes';
// import Prime from './pages/Primes/PrimeDetails';

import Paie from './pages/Paie/Paie';
import Payslips from './pages/Paie/Payslip/Payslips'; 
import PayslipsReport from './pages/Paie/Payslip/PayslipReport';


import FinancialStatements from './pages/FinancialStatements/FinancialStatements';

import Hsp from './pages/Leave/Hsp/Hsp';
import TimeManagement from './pages/Leave/Leave';
import Absence from './pages/Leave/Absence/Absence';
import { NotificationContainer } from 'react-notifications';
// import HeaderProfile from './components/Header/HeaderProfile';
import Settings from './pages/Settings/Settings';



function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [showLogoutModal, setShowLogoutModal] = useState(false);
  const isConnected = localStorage.getItem('isConnected');

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setIsSidebarOpen(true);
      } else {
        setIsSidebarOpen(false);
      }
    };

    // Charger l'état de la sidebar depuis localStorage
    const sidebarState = localStorage.getItem('sidebarCollapsed');
    if (sidebarState) {
      setIsSidebarCollapsed(sidebarState === 'true');
    }

    window.addEventListener('resize', handleResize);

    // Initial check
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  // Surveiller les changements d'état de la sidebar
  useEffect(() => {
    const handleSidebarStateChange = () => {
      const sidebarState = localStorage.getItem('sidebarCollapsed');
      if (sidebarState) {
        setIsSidebarCollapsed(sidebarState === 'true');
      }
    };

    // Utiliser un écouteur d'événements de stockage pour détecter les changements
    window.addEventListener('storage', handleSidebarStateChange);

    return () => {
      window.removeEventListener('storage', handleSidebarStateChange);
    };
  }, []);

  const handleLogoutRequest = () => {
    setShowLogoutModal(true);
  };

  const handleLogoutConfirm = () => {
    apiService.logoutUser();
    setShowLogoutModal(false);
  };

  const handleLogoutCancel = () => {
    setShowLogoutModal(false);
  };

  return (
    <Router>
        {isConnected && <SidebarNav 
          isOpen={isSidebarOpen} 
          isCollapsed={isSidebarCollapsed}
          setIsCollapsed={setIsSidebarCollapsed}
          onLogoutRequest={handleLogoutRequest}
        />}
        <div className={`flex-1 p-5 bg-[var(--bg-color)] min-h-screen ${
          isConnected ? (
            isSidebarCollapsed ? 'ml-[70px]' : 'ml-[250px]'
          ) : 'ml-0'
        } lg:transition-all lg:duration-300`}>
          {/* if the user is connected */}
          {/* {isConnected && <HeaderProfile />}           */}
          <Routes>
            {isConnected ? (
              <>
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Home />} />
                {/* <Route path="/calendar" element={<Calendar />} /> */}
                <Route path="/settings" element={<Settings />} />

                <Route path="/employees" element={<Employees />} />
                <Route path="/employees/new" element={<EmployeeNew />} />
                <Route path="/employees/:id" element={<Employee />} />

                <Route path="/primes" element={<Primes />} />

                <Route path='/etats' element={<FinancialStatements />} />

                <Route path="/hsp" element={<Hsp />} />
                <Route path="/absence" element={<Absence />} />                
                <Route path="/leave" element={<TimeManagement />} />

                <Route path="/paie" element={<Paie />} />

                <Route path="/contracts" element={<Contracts />} />

                <Route path="/payslips" element={<Payslips />} />
                <Route path="/payslip/report" element={<PayslipsReport />} />
              </>
            ) : (
              <>
                <Route path="/" element={<Login />} />
                <Route path="/login" element={<Login />} />
              </>
            )}
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/inscription" element={<CreateUserCompany />} />
            <Route path="/deconnexion" element={<Deconnexion />} />
          </Routes>
          {/* <Footer /> */}
        </div>
        <NotificationContainer />

        {/* Utilisation du composant LogoutModal */}
        <LogoutModal 
          isOpen={showLogoutModal}
          onConfirm={handleLogoutConfirm}
          onCancel={handleLogoutCancel}
        />
    </Router>
  );
}

export default App;